import { render, staticRenderFns } from "./HaveYouMetCards.vue?vue&type=template&id=d8e0cd52&scoped=true"
import script from "./HaveYouMetCards.vue?vue&type=script&lang=js"
export * from "./HaveYouMetCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8e0cd52",
  null
  
)

export default component.exports